import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMWComponent } from './kymw.component';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FunctionMenuModule } from '../commons/kymw02/function-menu/function-menu-module';
import { KYMW1001Module } from './kymw10/kymw1001/kymw1001.module';
import { LogoutService } from './api-services/logout.service';



@NgModule({
  declarations: [
    KYMWComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbTooltipModule,
    FunctionMenuModule,
    KYMW1001Module
  ],
  providers:[
    LogoutService
  ]
})
export class KYMWModule { }
